<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.animal_id" placeholder="请选择类型id" clearable>

      </el-select>
      <el-input v-model="listQuery.name" placeholder="请输入类型名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.order_no" placeholder="请输入排序" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />

      <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'AnimalType.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'AnimalType.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column align="center" prop="animal_id" label="类型id "> </el-table-column>
      <el-table-column align="center" prop="name" label="类型名称 "> </el-table-column>
      <el-table-column align="center" prop="order_no" label="排序 "> </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>

      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'AnimalType.delete'" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">删除</el-button>
          <el-button v-auth="'AnimalType.update'" plain icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="类型id" prop="animal_id">
          <el-select v-model="temp.animal_id" placeholder="请选择">

          </el-select>
        </el-form-item>
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="排序" prop="order_no">
          <el-input v-model="temp.order_no" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/baseset/animal_type' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor'
// import FileList from '@/components/attachment/FileList'
import dict_data from '@/api/system/dict_data'

export default {
  name: 'AnimalType',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      // 字典参数
      dictionary: []
      // 字典参数
    }
  },
  created() {
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: '' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        name: ''
      }
    }
  }
}
</script>
